import { NgTemplateOutlet } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { Observable } from "rxjs";
import { FullProjectHash } from "../../../../_models/project.interface";
import { FormModalComponent } from "../form-modal-component.class";

@Component({
  selector: "hawk-edit-project-deadlines-modal",
  imports: [ReactiveFormsModule, NgTemplateOutlet],
  templateUrl: "./edit-project-deadlines-modal.component.html",
  standalone: true,
  styleUrls: ["edit-project-deadlines-modal.component.scss"],
})
export class EditProjectDeadlinesModalComponent extends FormModalComponent<FullProjectHash, FullProjectHash> {
  @Input() override formGroup: UntypedFormGroup;
  @Output() override closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() override newDBOutput: EventEmitter<FullProjectHash> = new EventEmitter<FullProjectHash>();

  override formGroupToDBInput(): FullProjectHash {
    throw new Error("Method not implemented.");
  }

  override getDBCallObservable(object: FullProjectHash): Observable<FullProjectHash> {
    throw new Error("Method not implemented.");
  }
}
